import {
  InfoCircleFilled,
  LoadingOutlined,
  MailFilled,
  PrinterFilled,
} from '@ant-design/icons'
import { AppButton } from '@components/AppComponents'
import ModalConfirm from '@components/AppModal/ModalConfirm'
import EmailTemplateLink from '@components/EmailTemplateLink'
import PrintEmailContent from '@components/PrintEmailContent'
import { ApiService } from '@services/ApiService'
import router from '@stores/router'
import { downloadFileFromResponse, getQueryParams } from '@utils/functions'
import { Popover, notification } from 'antd'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import store from './store'

const OutstandingStatementPrint = () => {
  const params = getQueryParams(router.location.search, router.location.state)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const emailDoctorBookingDaysheets = () => {
    setShowModal(true)
  }
  useEffect(() => {
    document.title = 'Disbursement Statement'

    if (params) {
      setLoading(true)
      async function fetchData() {
        try {
          const data = await store.print(params)
          setData(data)
          setLoading(false)

          if (!data) {
            throw new Error('Cannot found')
          }
        } catch (error) {
          setLoading(false)
          setError(error)
        }
      }
      fetchData()
    } else {
      setError(new Error('Missing parameter'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div className="container text-center">
        <LoadingOutlined
          style={{ fontSize: '50px', color: 'var(--blue-400)' }}
        />
      </div>
    )
  }

  if (error) {
    return (
      <div className="container text-lg">
        <h1>Something Error</h1>
        <p>{error.message}</p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <div>
      {/* <div className="print-action-button" style={{ position: 'fixed', top: '20px', left: '300px', zIndex: 100000 }}>
        <div className="flex gap-2">
          <AppButton onClick={emailDoctorBookingDaysheets} color="blue" rounded className="flex items-center">
            <MailFilled /> <span className="mr-1">Email Daysheets</span>
            <Popover
              placement="top"
              content={
                <div>
                  Funding Statement will be sent to recipients email <EmailTemplateLink name="TEMPLATE_06" /> (no
                  bookings), <EmailTemplateLink name="TEMPLATE_07" /> (with bookings)
                </div>
              }
            >
              <InfoCircleFilled />
            </Popover>
          </AppButton>
        </div>
      </div> */}
      <PrintEmailContent
        html={data}
        title="Disbursement Statement"
        autoHeight
        capturePrintShortcut
      />
      {showModal && (
        <ModalConfirm
          modalParams={{
            message: 'Do you want to send funding statement to the recipents?',
            onOk: () => {
              setShowModal(false)
            },
          }}
          onCancel={() => {
            setShowModal(false)
          }}
        />
      )}
    </div>
  )
}

export default observer(OutstandingStatementPrint)
